module.exports = __webpack_public_path__ + "static/media/Aeonik-Medium.79b61679.otf";